import React from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import AuthService from '../services/auth.service';

var authService = new AuthService();

export const PrivateLinkContainer = ({ component: Component, ...rest }) => {
    let isAuthenticated = authService.isAuthenticated() || authService.isGuest();
    return isAuthenticated
        ?
        <LinkContainer {...rest} render={props => (
            <Component {...props} />
        )}
        />
        : null
};


// WEBPACK FOOTER //
// ./src/components/PrivateLinkContainer.js